import type { ReactNode } from "react";
import { Card } from "../ui/card";

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <Card className="flex min-h-52 flex-col items-center justify-center p-6 text-center">
      <h2 className="text-lg font-semibold text-navy-900">{title}</h2>
      {description ? <p className="mt-2 max-w-md text-sm text-slate-600">{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </Card>
  );
}
